import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import TradingView from '@/materials/atoms/TradingView.vue';
import { useStore } from '@/store/store';
import { onMounted, reactive, ref, watch } from 'vue';
import TradeTitle from '@/materials/atoms/TradeTitle.vue';
import { useMessage } from '@/const/messages';
export default /*#__PURE__*/ _defineComponent({
    props: {
        pair: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const { format, CHART_MESSAGES } = useMessage();
        const TVOptions = reactive({
            interval: '60',
            locale: store.state.userSettings.language,
        });
        const resetKey = ref(0);
        watch(() => [
            store.state.chart.isFull,
            store.state.userSettings.language,
            store.state.userSettings.localTime,
        ], () => {
            resetKey.value = resetKey.value === 0 ? 1 : 0;
        });
        const onFullScreen = (isFull) => {
            store.commit('setChartIsFull', isFull);
        };
        const containerId = 'chart_container';
        onMounted(() => {
            setTimeout(() => {
                const chartDiv = document.getElementById(containerId);
                if (!chartDiv || !chartDiv.hasChildNodes()) {
                    resetKey.value = resetKey.value === 0 ? 1 : 0;
                }
            }, 500);
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(TradeTitle, {
                    title: _unref(store).state.isSmartPhone ? '' : `${String(_unref(format)(_unref(CHART_MESSAGES).TITLE))} (${props.pair})`,
                    class: "title",
                    fullscreen: true,
                    help: true,
                    onChangeFull: onFullScreen
                }, null, 8, ["title"]),
                (_openBlock(), _createBlock(TradingView, {
                    pair: props.pair,
                    key: resetKey.value,
                    locale: _unref(TVOptions).locale,
                    containerId: containerId
                }, null, 8, ["pair", "locale"]))
            ], 64));
        };
    }
});
